import apiUrl from '../../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate';
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import moment from 'moment'
import CryptoJS from 'crypto-js';
import download from 'downloadjs';
import VueElementLoading from 'vue-element-loading';
import csvHelper from '../importjsontocsv';
import Vue from "vue";
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
export default {
	name: 'POShortExcessReport',
	components: {
		Paginate,
		DatePicker,
		download,
		JsonExcel,
		VueElementLoading
	},
	props: [],
	data() {
		return {
			isLoadingforxls: false,
			show: false,
      download: true,
      dataFilter2: '',
			reportname: '',
			csvFieldsForXls: {},
			listReportDataforxls: [],
			totalRows:0,
			ProductID: '',
			formattedDate: '',
			resultCount: '',
			ClientErr: '',
			WarehouseErr: '',
			clientid: '',
			warehouseid: '',
			warehouse: '',
			client: '',
			fromdate: '',
			todate: '',
			invreferenceid: '',
			pono: '',
			brand: '',
			user_type: '',
			perPage: 10,
			pageno: 0,
			pageCount: 0,
			isLoading: false,
			searchFlag: false,
			showSelectWarehouse: false,
			showSelectClient: false,
			listPOShortExcessReportDataCsv: [],
			listPOShortEReportData: [],
			csvFields: [],
			listClientData: [],
			listWarehouseData: [],

		}
	},
	computed: {

	},
	filters: {
		moment: function(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YYYY');
		}
	},
	mounted() {
		var permissionEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(permissionEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.createdbyEmail = userdetail.email;
		var today = new Date();
		this.formattedDate = moment(today).format('DD/MM/YYYY HH:mm:ss')
		this.reportname = this.$t('editedjson.poShortExcessReport')
		this.reportname = this.reportname + moment().format('DD-MM-YY_HH-mm-ss') + '.xls';
		//this.getPOShortEReportData();
		this.user_type = userdetail.utype;
		switch (this.user_type) {
			case 'system_user':
				this.showSelectClient = true;
				this.showSelectWarehouse = true;
				this.getClientList();
				this.getWarehouseList();
				break;

			case 'client_user':
				this.clientid = userdetail.clientid;
				this.clientid = this.client;
				this.getWarehouseList();
				this.showSelectWarehouse = true;
				break;

			case 'warehouse_user':
				this.loginUserEmail = userdetail.email;
				this.warehouseid = userdetail.warehouseid;
				this.warehouse = this.warehouseid;
				this.showSelectClient = true;
				this.getClientList();

				var roleids = userdetail.roleid.split(',');
				for (var i = 0; i < roleids.length; i++) {
					if (roleids[i] == 40) {
						this.purchasingManager = parseInt(roleids[i]);
					}
					if (roleids[i] == 41) {
						this.isInwardUserForPO = true;
					}
				}
				break;

			default:
				this.$alertify.error("Unauthorised user, Please contact your system admin");
				break
		}

	},
	methods: {
		Choosetype() {
			this.show = true;
			this.download = false;
			this.getPOShortEReportDataForXLS(3)
		},
		startDownload(){
		this.isLoadingforxls =true;
		},
		finishDownload(){
		this.isLoadingforxls =false;
		},
		export (data, filename, mime) {
			let blob = this.base64ToBlob(data, mime)
			download(blob, filename, mime)
		},

		base64ToBlob(data, mime) {
			let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
			let bstr = atob(base64)
			let n = bstr.length
			let u8arr = new Uint8ClampedArray(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new Blob([u8arr], {
				type: mime
			})
		},

		getClientList() {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;

			this.input = ({
				warehouseid: this.warehouseid,
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getWarehouseAssociatedClientList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr,
					}
				})
				.then(result => {
					this.listClientData = result.data.data;
				}, error => {
					console.error(error);
				});
		},

		getWarehouseList() {
			var userToken = window.localStorage.getItem('userToken')
			var myStr = userToken.replace(/"/g, '');
			this.pageno = 0;
			this.input = ({
				clientid: this.clientid,
			});

			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'getClientAssociatedWarehouseList',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					// console.log(result.data.data);
					this.listWarehouseData = result.data.data;
				}, error => {
					console.error(error)
				})
		},

		clientSelected() {
			if (this.clientid != this.client) {
				this.clientid = this.client;
				if (this.user_type != 'warehouse_user') {
					this.listWarehouseData = []
					this.getWarehouseList();
					if (this.listWarehouseData.find(entry => entry.warehouseid === this.warehouse)) {
						this.warehouse = this.warehouseid = '';
					} else {
						this.warehouse = ''
					}
				} else {
					if (this.warehouseid && this.clientid);
					// this.getPOShortEReportData();
				}
			}
			this.listPOShortEReportData = [];
			this.pageno = this.pageCount = 0;
		},

		warehouseSelected() {
			this.warehouseid = this.warehouse;
			this.pageno = this.pageCount = 0;
			if (this.warehouseid) {
				if (this.clientid) {
					// this.getPOShortEReportData();
				} else {
					this.getClientList();
				}
			}
		},

		//to get client list
		getPOShortEReportData(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			var fr_date = '';
			var to_date = '';
			var dataFilter = {};
			if (csvCheck == 2){
				this.show=false;
				this.download =true;
			}
			// this.ClientErr = '';
			if (this.clientid == '' || this.client == '') {
				this.ClientErr = 'Client is required';
				this.pageNo = this.pageCount = 0;
				this.listPOShortEReportData = [];
				return false;
			}
			if (this.warehouseid == '' || this.warehouse == '') {
				this.WarehouseErr = this.$t('common.warehouseError');
				this.pageNo = this.pageCount = 0;
				this.listPOShortEReportData = [];
				return false;
			}

			if (this.fromdate == '') {
				fr_date = '';
			} else {
				fr_date = this.dateFormat(this.fromdate, 0);
			}
			if (this.todate == '') {
				to_date = '';
			} else {
				to_date = this.dateFormat(this.todate, 1);
			}
			this.isLoading = true;
			// if (csvCheck != 1)
			// this.pageno = 0;
			this.input = ({
				clientid: this.clientid,
				warehouseid: this.warehouseid,
				pono: this.pono,
				invreferenceid: this.invreferenceid,
				brand: this.brand,
				productid: this.ProductID,
				eancode: this.eancode,
				fromddate: fr_date,
				todate: to_date,
				offset: this.pageno,
				limit: this.perPage,
				csvData: csvCheck,
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					dataFilter[k] = v;
				}
				  })
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'poShortExcessReport',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (csvCheck == 1) {
						this.show = true;
						this.download = false;
						this.listPOShortExcessReportDataCsv = [];
						this.csvFields = {
							'pono': this.$t('editedjson.productNo'),
							'productid': this.$t('common.productId'),
							'eancode': this.$t('common.eanCode'),
							'productname': this.$t('common.productName'),
							'mrp': this.$t('removeHold.productMrp'),
							'brand':  this.$t('common.brandName'),
							'invreferenceid': this.$t('removeHold.drId'),
							'shortexcessqty': this.$t('editedjson.shortExcessQty'),
							'createddate': this.$t('removeHold.grnDate'),
						};
						var dateFilter = ['createddate'];
						var skipFilter = [];
						this.listPOShortExcessReportDataCsv = result.data.data;
						csvHelper.data.jsonToCSV(this.$t('editedjson.poShortExcessReport'), this.listPOShortExcessReportDataCsv, this.csvFields, dateFilter, skipFilter, dataFilter);

						// this.jsonToCSV('POShortExcessReport', this.listPOShortExcessReportDataCsv, this.csvFields, dateFilter, skipFilter);
					} else {
						this.listPOShortEReportData = result.data.data;
						if (result.data.errorCode == -1) {
							this.resultCount = 0;
						} else {
							this.totalRows = result.data.count;
							this.resultCount = result.data.count;
							if (this.totalRows <= this.perPage) {
								this.pageCount = 1;
							} else {
								this.pageCount = Math.ceil(this.totalRows / this.perPage);
							}
						}
					}
					this.isLoading = false;
				}, error => {
					console.error(error);
				})
		},
		getPOShortEReportDataForXLS(csvCheck = 0) {
			var userToken = window.localStorage.getItem('userToken');
			var myStr = userToken.replace(/"/g, '');
			var fr_date = '';
			var to_date = '';
			this.show = true;
			this.download = false;
			this.dataFilter2 = [];
			var value = '';
			var str = '';


			if (this.fromdate == '') {
				fr_date = '';
			} else {
				fr_date = this.dateFormat(this.fromdate, 0);
			}
			if (this.todate == '') {
				to_date = '';
			} else {
				to_date = this.dateFormat(this.todate, 1);
			}

			// if (csvCheck != 1)
			// this.pageno = 0;
			this.input = ({
				clientid: this.clientid,
				warehouseid: this.warehouseid,
				pono: this.pono,
				invreferenceid: this.invreferenceid,
				brand: this.brand,
				productid: this.ProductID,
				eancode: this.eancode,
				fromddate: fr_date,
				todate: to_date,
				offset: this.pageno,
				limit: this.perPage,
				csvData: csvCheck,
			});
			Object.entries(this.input).forEach(([k, v]) => {
				let skipkeys = ['offset', 'limit', 'csvData'];
				if (v != null && v != '' && skipkeys.indexOf(k) == -1) {
					value += k + ':' + v + ','
					this.dataFilter2 = str.concat(value);

				}
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url + 'poShortExcessReport',
					'data': this.input,
					headers: {
						'Authorization': 'Bearer ' + myStr
					}
				})
				.then(result => {
					if (csvCheck == 3) {
							if (result.data.data.length > 0) {
								this.listReportDataforxls = [];
								this.csvFieldsForXls =[];
								this.csvFieldsForXls[this.$t('editedjson.productNo')] = 'pono',
								this.csvFieldsForXls[this.$t('common.productId')] = 'productid',
								this.csvFieldsForXls[this.$t('common.eanCode')] = 'eancode',
								this.csvFieldsForXls[this.$t('common.productName')] = 'productname',
								this.csvFieldsForXls[this.$t('removeHold.productMrp')] = 'mrp',
								this.csvFieldsForXls[this.$t('common.brandName')] = 'brand',
								this.csvFieldsForXls[this.$t('removeHold.drId')] = 'invreferenceid',
								this.csvFieldsForXls[this.$t('editedjson.shortExcessQty')] = 'shortexcessqty',
								this.csvFieldsForXls[this.$t('removeHold.grnDate')] = 'createddate'

								this.listReportDataforxls = result.data.data;
							}
							else {
									if (result.data.status == true) {
										this.$alertify.success('Report size is large. Please download from Data Transmission -> Download Reports');
									} else {
										this.$alertify.error(result.data.msg.message);
									}
								}


					}


				}, error => {
					console.error(error);
				})
		},
		//to get pagination
		getPaginationData(pageNum) {
			this.pageno = (pageNum - 1) * this.perPage;
			this.getPOShortEReportData();
		},

		dateFormat(date, toFrom) {
			if (!toFrom)
				toFrom = '00:00:00'
			else
				toFrom = '23:59:59'
			if (!date)
				return '';
			return moment(date).format('YYYY-MM-DD ' + toFrom);
		},

		dateFormatFRT(date) {
			if (!date) return '';
			return moment(date).format('DD-MM-YY HH:mm:ss');
		},

		//to reset search form
		resetSearchForm() {
			this.show=false;
      this.download =true;
			this.ProductID = '';
			this.orderid = '';
			this.rackid = '';
			this.brand = '';
			this.pageno = 0;
			this.totalRows =0;
			this.listPOShortEReportData = [];
			this.fromdate = '';
			this.todate = '';
			if (this.user_type == 'warehouse_user')
				this.client = '';
			else if (this.user_type == 'client_user')
				this.warehouse = '';
			else {
				this.client = '';
				this.warehouse = '';
			}
		},
	}
}



// WEBPACK FOOTER //
// ./src/views/components/reports/poshortexcessreport/poshortexcessreport.component.js